export default __webpack_public_path__ + "static/media/logo-acreditacion-UDD-blanco.81863450.png";